// Maps a terminal id → its paste fn, so the drag layer can drop text into
// whichever terminal is under the cursor without prop-drilling through the
// whole TerminalPane tree.
const registry = new Map<string, (text: string) => void>();

export function registerTerminalPaste(id: string, paste: (text: string) => void): () => void {
  registry.set(id, paste);
  return () => {
    if (registry.get(id) === paste) registry.delete(id);
  };
}

export function pasteIntoTerminal(id: string, text: string): boolean {
  const paste = registry.get(id);
  if (!paste) return false;
  paste(text);
  return true;
}
